// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"6166d50d","144":"e27a3474","217":"a423730e","256":"f21fa4fc","543":"7d4edaa0","940":"51488057"}[chunkId] + ".css";
};